module.exports = __webpack_public_path__ + "static/soyFree-4effa3e4698b8864a837b8889b1913e6.png";